import React, { useEffect, useRef, useState } from "react";
import "./Video.css";
import { GuideData, GuidePreview } from "../../../core/types/guide";
import { oembed } from "@loomhq/loom-embed";
import { OEmbedInterface } from "@loomhq/loom-embed/dist/.types/oembed";
import logger from "../../../utils/logger";
import playIcon from "../../../assets/svgs/playIcon";
import pauseIcon from "../../../assets/svgs/pauseIcon";
import logoIcon from '../../../assets/svgs/logoIcon';

import 'vidstack/styles/defaults.css';
import 'vidstack/styles/community-skin/video.css';
import { MediaCommunitySkin, MediaOutlet,useMediaStore, MediaPlayer, MediaPoster, MediaPlayButton, useMediaRemote } from '@vidstack/react';
import type { MediaPlayEvent, MediaPlayFailEvent, MediaPlayRequestEvent, MediaPauseEvent, MediaPlayerElement } from 'vidstack';


import Icon from "../../../ui/Icon/Icon";
import useWindowSize from "../../../hooks/useWindowSize";
import { Device } from "../../../types/devices";
import { captureEvent } from "../../../core/analytics/analytics";

type VideoProps = {
    video: GuideData["video"];
    videoSrc?: string
    guidePreview?:GuidePreview
    overrideDevice?:Device,
};
/**
 *  calculateMediaDuration()
 *  Force media element duration calculation.
 *  Returns a promise, that resolves when duration is calculated
 **/
function calculateMediaDuration(media: HTMLMediaElement) {
    return new Promise((resolve, reject) => {
        media.onloadedmetadata = function () {
            // set the mediaElement.currentTime  to a high value beyond its real duration
            media.currentTime = Number.MAX_SAFE_INTEGER;
            // listen to time position change
            media.ontimeupdate = function () {
                media.ontimeupdate = function () {};
                // setting player currentTime back to 0 can be buggy too, set it first to .1 sec
                media.currentTime = 0.1;
                media.currentTime = 0;
                // media.duration should now have its correct value, return it...
                resolve(media.duration);
            };
        };
    });
}

const Video: React.FC<VideoProps> = (props) => {
    const recorderType: "default" | "loom" | undefined = props.video.metadata?.recorderType;
    const vidRef = useRef<HTMLVideoElement>(null);
    const [button, setButton] = useState(true)
	const [videoHTML, setVideoHTML] = useState<string>("");

    const [firstPlay, setFirstPlay] = useState(false)
    const [flashPlay, setFlashPlay] = useState(false)
    const [flashPause, setFlashPause] = useState(false)

    const [subtitleSrc, setSubtitleSrc] = useState("")

    // ERROR ---- One or both of these two lines is causing error: 
    const player = useRef<MediaPlayerElement>(null);
    const { paused } = useMediaStore(player);
    const remote = useMediaRemote(player)

    var device: Device = useWindowSize().device
    if(props.overrideDevice) device= props.overrideDevice

    const handlePlay = () => {
        setButton(false);
        if (vidRef.current) {
            vidRef.current.play();
        }
    };

    const handlePause = () => {
        if (vidRef.current) {
            vidRef.current.pause();
        }
    };

    useEffect(()=>{
        if (firstPlay){
            captureEvent({eventName: "VideoPlayedInHelpCenter", value: {guide_id: props.guidePreview?.id as string}})
        }
    }, [firstPlay, props.guidePreview?.id])

    const onMediaPlay = (event: MediaPlayEvent) => {

        console.log("playign!")

        if (!firstPlay){
            setFirstPlay(true)
        }
        setFlashPlay(true)

        setTimeout(() => {
            setFlashPlay(false)
        },200)

    }

    const onMediaPause = (event: MediaPauseEvent) => {

        setFlashPause(true)

        setTimeout(() => {
            setFlashPause(false)
        }, 200)
        
    }

    useEffect(() => {

        logger.debug("vidref.current: ", vidRef.current)
        logger.debug("src: ", props.video.metadata?.generatedVideo?.src)

        if (device==="mobile" && vidRef.current && (recorderType === "default" || !recorderType)) {
            calculateMediaDuration(vidRef.current);
        }

		if (recorderType === "loom"){
			oembed(props.video.src).then((obj:OEmbedInterface)=>{
				setVideoHTML(obj.html)
			})
		}
        
    }, []);


    if ((recorderType === "default" || !recorderType) && device==="laptop") {
        
        logger.debug("building for ")

        

        return (
            // <div>Hello there!</div>
            <div className="gigauser-video-container" 
                // onClick={button?handlePlay:undefined}
            >

                {/* <div
                    style={{visibility: (button)?"visible":"hidden"}} 
                    className={`gigauser-play-button`}></div> */}

                <MediaPlayer
                    onPlay={onMediaPlay}
                    onPause={onMediaPause}
                    ref={player}
                    title ={props.guidePreview?.header.name}
                    src={props.videoSrc || props.video.src}
                    poster="https://media-files.vidstack.io/poster.png"
                    className={`${!firstPlay?"thumbnail-preview":""} ${device==="laptop"?"gigauser-laptop-mediaplayer":"gigauser-mobile-mediaplayer"}`}

                    // poster="https://image.mux.com/VZtzUzGRv02OhRnZCxcNg49OilvolTqdnFLEqBsTwaxU/thumbnail.webp?time=268&width=980"
                    // thumbnails="https://media-files.vidstack.io/sprite-fight/thumbnails.vtt"
                    // aspectRatio={16 / 9}
                    // crossorigin=""
                >
                    
                    {/* <div className={`thumbnail-play ${paused?"video-paused":"video-playing"}`}>
                        
                        
                        <MediaPlayButton />
                        <CanvasPlayerCluesoPreview />
                    </div> */}

                    <div className={`thumbnail-play ${paused?"video-paused":"video-playing"}`}
                        onClick={() => {remote.play()}}
                    >
                        <div className='thumbnail-play-icon-container'>
                            <div className='thumbnail-play-bg'></div>
                            <div className='thumbnail-play-icon'>{playIcon("white")}</div>

                        </div>
                        <CanvasPlayerCluesoPreview />
                        
                    </div>

                    <MediaOutlet >

                        {/* <MediaPoster alt = {props.guidePreview?.header.name} /> */}
                        
                        <div className={`flash-play ${flashPlay || flashPause ? "flash-show":""}`}>
                        {
                            flashPlay?
                            <Icon className="flash-icon-container">{playIcon("white")}</Icon>
                            :
                            flashPause?
                            <Icon className="flash-icon-container">{pauseIcon("white")}</Icon>
                            : 
                            null
                            }
                        </div>
                        
                        {
                        props.video.metadata.generatedVideo?.subtitles && 
                            <track
                                label="English"
                                kind="subtitles"
                                srcLang="en"
                                src={props.video.metadata.generatedVideo?.subtitles}
                                // default
                            />
                        }
                    </MediaOutlet>
                
                <MediaCommunitySkin />
                </MediaPlayer>


                
            </div>
            
        );
    } 

    else if ((recorderType==="default" || !recorderType)  ){

        return (
            <video
                    ref={vidRef}
                    preload="metadata"
                    controls
                    className={`gigauser-editor-video `}
                    src={props.videoSrc || props.video.src}
                    // onPlay={handlePlay}
                    // onPause={handlePause}

                >
                    {props.video.metadata.generatedVideo?.subtitles && 
                        <track
                        label="English"
                        kind="subtitles"
                        srcLang="en"
                        src={props.video.metadata.generatedVideo?.subtitles}
                        />
                    }
            </video>
        )

    }
    
    else if (recorderType === "loom") {
		return (
			<div dangerouslySetInnerHTML={{ __html: videoHTML }}></div>
		)
    } else {
        return <></>;
    }
};

type CanvasPlayerCluesoPreviewProps = {

}


const CanvasPlayerCluesoPreview:React.FC<CanvasPlayerCluesoPreviewProps> = () => {
    
    return (
        <a className="thumbnail-clueso-preview" href="https://www.clueso.io/features/video-tutorials" target="_blank">
            <span>Made in</span>
            <div className="thumbnail-clueso-logo">{logoIcon()}</div>
            {/* <img className="thumbnail-clueso-logo"></img> */}
        </a>
    )
}

export default Video;
